import React from "react";
import { Container, Paper, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  paper: { padding: "50px", textAlign: "center" },
  weirdFlexButOkay: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  },
});

export const FourOhFour = () => {
  const { paper, weirdFlexButOkay } = useStyles();

  return (
    <Container maxWidth="md" className={weirdFlexButOkay}>
      <Paper className={paper}>
        <Typography variant="h5">
          No page with that url can be found, did you mistype it?
        </Typography>
      </Paper>
    </Container>
  );
};
